<template>
  <div v-if="isShow" class="tag-age">
    <img :src="imageFileName()" :alt="ageLimitsText" />
  </div>
</template>

<script>
  export default {
    props: {
      targetAge: {
        type: Number,
      },
      ageTag: {
        type: String,
      },
      contentType: {
        type: String,
      },
    },
    computed: {
      isShow() {
        return (
          this.targetAge === 'adult' ||
          this.ageTag === '19' ||
          this.targetAge >= 18
        )
      },
      ageLimitsText() {
        if (this.targetAge >= 18) {
          return '청소년 관람 불가'
        } else if (this.targetAge === 0) {
          return '전체 관람가'
        } else if (this.targetAge) {
          return this.targetAge + '세 관람가'
        }
        return ''
      },
    },
    methods: {
      imageFileName() {
        // adult only
        let imagePath = require.context(
          '../../assets/images/common/',
          false,
          /\.png$/,
        )
        return this.ageTag === 'adult' || this.contentType === 'movie'
          ? imagePath('./tag-age21.png')
          : imagePath('./tag-age19-v2.png')
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tag-age {
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
</style>
